// extracted by mini-css-extract-plugin
export default {"ThemeLogo":"A1MLightLogo","KeenanLogo":"Keenan-logo"};